import React from "react";
import PriceSettingControl from "./PriceSettingControl";
import PriceSettingInput from "./PriceSettingInput";

const MODE = {
  CONTROL: "CONTROL",
  INPUT: "INPUT",
};
class PriceEditModeControl extends React.PureComponent {
  constructor(props) {
    super(props);

    const { prices, preventInitCheck = true } = this.props;

    this.state = {
      preventInitCheck,
      prices,
      selectedMode: MODE.INPUT,
    };

    this.handlePriceChanged = this.handlePriceChanged.bind(this);
  }

  handlePriceChanged(prices) {
    this.setState({ prices, preventInitCheck: false });
    if (this.props.handleSync) {
      this.props.handleSync(prices);
    }
  }

  render() {
    const {
      handleValidChanged,
      limit,
      showErrMsg = true,
      supportAlgo = false,
    } = this.props;
    const { prices, selectedMode, preventInitCheck } = this.state;

    return (
      <div>
        <div className="border rounded inline-flex overflow-hidden border-gray-300">
          <button
            type="button"
            className={`focus:outline-none px-4 text-sm font-semibold ${
              selectedMode === MODE.INPUT
                ? "bg-blue-400 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => this.setState({ selectedMode: MODE.INPUT })}
          >
            Input Mode
          </button>
          <button
            className={`focus:outline-none px-4 text-sm font-semibold ${
              selectedMode === MODE.CONTROL
                ? "bg-blue-400 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => this.setState({ selectedMode: MODE.CONTROL })}
            type="button"
          >
            Select Mode
          </button>
        </div>
        <div className="mt-2">
          {selectedMode === MODE.CONTROL ? (
            <PriceSettingControl
              prices={prices}
              limit={limit}
              supportAlgo={supportAlgo}
              preventInitCheck={preventInitCheck}
              showErrMsg={showErrMsg}
              handleSync={this.handlePriceChanged}
              handleValidChanged={(flag) => handleValidChanged(flag)}
            />
          ) : (
            <PriceSettingInput
              prices={prices}
              limit={limit}
              supportAlgo={supportAlgo}
              preventInitCheck={preventInitCheck}
              showErrMsg={showErrMsg}
              handleSync={this.handlePriceChanged}
              handleValidChanged={(flag) => handleValidChanged(flag)}
            />
          )}
        </div>
      </div>
    );
  }
}

export default PriceEditModeControl;
